import React, { Component  } from 'react';
import HeaderBar from './Components/Shared/HeaderBar';
import BottomBar from './Components/Shared/BottomBar';
import {createMuiTheme} from '@material-ui/core/styles';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { HashRouter, Route, Switch } from "react-router-dom";
import ProductionOrderIndexPage from './Components/Nav/ProductionOrderIndexPage';
import OrderHistoryPage from './Components/Nav/OrderHistoryPage';
import PlanningIndexPage from './Components/Nav/PlanningIndexPage';
import HomePage from './Components/Nav/HomePage';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as Actions from './actions'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux'
import HelpPage from './Components/Nav/HelpPage';
import OrderInfoPage from './Components/Nav/OrderInfoPage';
import history from './helpers/history';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CncInfoPage from './Components/Nav/CncInfoPage';

const theme = createMuiTheme({
  typography: {
    fontFamily: "\"Helvetica\", \"Arial\", sans-serif"
  },
  palette: {
    primary: {
      main: '#fafafa',
      secondary: '#1976d2'
    },
    secondary: {
      main: '#1976d2',
      secondary: '#fafafa'
    },
  },
});

class App extends Component {
  constructor(props){
    super(props);

    this.appMainContainer = React.createRef();
  }

  state = {
    value: "nl"
  };

  // componentDidMount() {
  //     history.push(window.location);
  // };

  handleChange = event => {
    console.log("selected val is ", event.target.value);
    let newlang = event.target.value;
    this.setState(prevState => ({ value: newlang }));
    console.log("state value is", newlang);
    this.props.i18n.changeLanguage(newlang);
  };

  render() {
    let {actions, nav, orderHist, prodOrderHist, planning} = this.props;

    return(
    <div className="App" ref={(element) => {this.appMainContainer = element;}}>
        <HashRouter history={history} forceRefresh={true}>
          <MuiThemeProvider theme={theme}>
            <HeaderBar Title = {nav.Title} AdditionalTitleInfo={nav.AdditionalTitleInfo}></HeaderBar>
            <div className="Spacer100"></div>
            <div className="container">
              <Switch>
                <Route exact path="/" component={() => <HomePage setHeader={actions.setHomePage}></HomePage>} />
                <Route path="/productionOrderIndex" component={() => <ProductionOrderIndexPage actions={actions} setHeader={actions.setProdPage} setProdOrderHist={actions.setProdOrderHist} searchText={prodOrderHist.SearchText}></ProductionOrderIndexPage>} />
                <Route path="/orderHistoryIndex" component={() => <OrderHistoryPage setHeader={actions.setOrderHistoryPage} setOrderHist={actions.setOrderHist} searchText={orderHist.SearchText}></OrderHistoryPage>} />
                <Route path="/planningIndex" component={() => <PlanningIndexPage startDate={planning.startDate} endDate={planning.endDate} setHeader={actions.setPlanningPage} setPlanningSearchDates={actions.setPlanningSearchDates}></PlanningIndexPage>} />
                <Route path="/help" component={() => <HelpPage setHeader={actions.setHelpPage}></HelpPage>} />
                <Route path="/cncInfoIndex/:ordernumber/:productionOrderID" component={(matchProps) => <CncInfoPage {...matchProps} {...this.props} setHeader={actions.setCncInfoPage}></CncInfoPage>}/>
                <Route path="/order/:ordernumber/:productionOrderID" component={(matchProps) =>  <OrderInfoPage {...matchProps} {...this.props} setHeader={actions.setOrderInfoPage}></OrderInfoPage>} />
                {/* <Route component={() => <HomePage setHeader={actions.setHomePage}></HomePage>} /> */}
                <Route onEnter={() => window.location.reload()} />
              </Switch>
            </div>
            <ToastContainer />
            <div className="Spacer100"></div>
            <BottomBar i18n = {this.props.i18n} /*Title = {nav.Title}*/ ShowBottomBarAction = {nav.ShowBottomBarAction} 
              BottomBarActionTitle = {nav.BottomBarActionTitle} BottomBarAction = {nav.BottomBarAction} History={history} ></BottomBar>
          </MuiThemeProvider>
        </HashRouter>
    </div>
    )
  }
}

const mapStateToProps = state => ({
  nav: state.nav,
  orderHist: state.orderHist,
  prodOrderHist: state.prodOrderHist,
  planning: state.planning
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(withTranslation(), connect(
  mapStateToProps,
  mapDispatchToProps
))(App);